define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/selector.js
// module id = 121
// module chunks = 0